import * as React from 'react';

import { ICipChatbotData } from './cip-chatbot.data';
import { ICipChatbotProps } from './cip-chatbot.props.autogenerated';
import { INodeProps } from '@msdyn365-commerce-modules/utilities';

export interface ICipChatbotViewProps {
    agentFrameProps: INodeProps;
    agentFrame?: React.ReactNode;
}

interface AgentFrameProps {
    props: {
        config: {
            target: {
                destinationUrl: string;
            };
        };
    };
}

/**
 *
 * CipChatbot component
 * @extends {React.PureComponent<ICipChatbotProps<ICipChatbotData>>}
 */
class CipChatbot extends React.PureComponent<ICipChatbotProps<ICipChatbotData>> {
    public render(): JSX.Element | null {
        const { isAuthenticated } = this.props.context.actionContext.requestContext.user;

        const getCustomerSpecificAgentFrame = () => {
            const agentFrame = this.props.slots.agentFrame?.[0] as AgentFrameProps;

            if (agentFrame) {
                const destinationUrl = agentFrame.props.config.target.destinationUrl;
                const customerAccountNumber = this.props.context.request.user.customerAccountNumber;

                if (destinationUrl && customerAccountNumber) {
                    agentFrame.props.config.target.destinationUrl = `${destinationUrl}&customerAccountNumber=${customerAccountNumber}`;
                }
            }

            return agentFrame;
        };

        if (this.props.config.moduleHide || !isAuthenticated) {
            return null;
        }

        const agentFrame = getCustomerSpecificAgentFrame();

        const viewProps = {
            ...this.props,
            agentFrameProps: { className: 'cip-chatbot__agentFrame' },
            agentFrame
        };

        return this.props.renderView(viewProps);
    }
}

export default CipChatbot;
